module.exports = __webpack_public_path__ + "public/img/slider/slide-3.gif";